

import compPacking from '../update/packing'
import { HttpTransferBillList } from '@/service/boss/shipment'
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        compPacking
    },
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpTransferBillList,
        interceptRequest(params) {
            const search = { ...params.search };
            const { EQ_lineId = "", CN_erpSku = "", CN_logisticNos = "", GE_estimateArrivalAt } = search;
            const createdAt = (GE_estimateArrivalAt || "").split('~');
            search.GE_estimateArrivalAt = createdAt[0];
            search.LE_estimateArrivalAt = createdAt[1];
            delete search.EQ_lineId;
            delete search.CN_erpSku;
            delete search.CN_logisticNos;
            return {
                ...params,
                filters: `{"groupOp": "AND", "rules": [{ "field": "shipmentPlansEntity.lineId", "op": "eq", "data": "${EQ_lineId}" },{ "field": "shipmentPlansEntity.logisticNos", "op": "cn", "data": "${CN_logisticNos}" },{ "field": "shipmentPlansEntity.erpSkus", "op": "cn", "data": "${CN_erpSku}" }]}`,
                search
            };
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'headquery':
                case 'query':
                    const url = this.$router.resolve({
                        name: type === 'query' ? 'spBillChildDetail' : 'spBillupdate',
                        params: { type: 'query' },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'download': this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/ShipmentPlan/export', { id: params }, 'download'); break;
                case 'packing': {
                    this.operate = {
                        title: '查看装箱',
                        show: true,
                        width: 1000,
                        component: "compPacking",
                        startUp: true,
                        initFormData: {
                            inboundPlanOrderNo: params
                        }
                    };
                }; break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '查看装箱',
                show: true,
                params: id,
                operate: 'packing'
            }, {
                label: '导出',
                show: true,
                params: id,
                operate: 'download'
            }]
        },

    },
    computed: {
        // ...mapState('boss', ['products', 'warehouseList']),
        ...mapGetters('diction',['getNewProductList','getNewWarehouseIdList']),
        SearchsData() {
            return [
                {
                    label: "头单据编号",
                    tag: 'vInput',
                    key: 'EQ_shipmentNo',
                    show: true,
                },
                {
                    label: "子单据编号",
                    tag: 'vInput',
                    key: 'EQ_transferNo',
                    show: true,
                },
                {
                    label: "采购单",
                    tag: 'vInput',
                    key: 'EQ_sourceOrderNos',
                    show: true,
                },
                {
                    label: "ERP SKU",
                    tag: 'vInput',
                    key: 'CN_erpSku',
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getNewProductList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "Shipment ID",
                    tag: 'vInput',
                    key: 'EQ_shipmentId',
                },
                {
                    label: "Referrence ID",
                    tag: 'vInput',
                    key: 'EQ_referrenceId',
                },
                {
                    label: "物流单号",
                    tag: 'vInput',
                    key: 'CN_logisticNos',
                },

                {
                    label: "预计到货日期",
                    tag: 'vDatepicker',
                    key: 'GE_estimateArrivalAt',
                    props: {
                        format: 'yy-mm-dd~yy-mm-dd',
                        confirm: false,
                    },
                },


            ]
        },
        columns() {
            return [{
                title: '操作',
                width: 70,
                render: this.getOperateNodes,
            }, {
                title: '单号信息',
                key: 'shipmentNo',
                minWidth: 160,
                render: (h, { row }) => {
                    return <div>
                        <div>发运单号:<a onClick={this.handleOperates.bind(this, row.parentId, 'headquery')}>{row.shipmentNo}</a></div>
                        子运单号:<a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.transferNo}</a>
                    </div >;
                }
            }, {
                title: '采购单号',
                key: 'sourceOrderNos',
            }, {
                title: '子单据状态',
                key: 'orderStatus',
                render(h, { row }) {
                    const status = {
                        establish: '已创建',
                        submit: '已提交',
                        confirm: '已确认',
                        reject: '已驳回',
                        shipment: '已发运',
                        complete: '已完成',
                        close: '已取消',
                        // delete: '已删除',
                        draft: '草稿',
                    };
                    return status[row.orderStatus] || '';
                }
            }, {
                title: '项目',
                key: 'lineId',
                render: (h, { row }) => {
                    const id = row.lineId;
                    const data = this.getNewProductList.find((item) => {
                        return id == item.value
                    }) || {};
                    return data.label
                },
            }, {
                title: '发运信息',
                key: 'carrierType',
                render: (h, { row }) => {
                    const id = row.orgWarehouseId;
                    const data = this.getNewWarehouseIdList.find((item) => {
                        return id == item.value
                    }) || {};
                    return <div>
                        <div>目的仓:{data.label}</div>
                        Shipment ID:{row.shipmentId}
                    </div>
                }
            }, {
                title: '创建时间',
                key: 'createdAt',
                sortable: true
            }, {
                title: '创建人',
                key: 'createdName',
                render(h, { row }) {
                    const createdName = row.createdName;
                    return (createdName === 'none' || !createdName) ? '-' : createdName;
                },
                sortable: true
            }];
        },
    },
};




